import { buildAnimationClasses } from './useWidgetAnimation';

export function StaticImageWidget({ fields }: { fields: Record<string, unknown> }) {
  const src = typeof fields.src === 'string' && fields.src.trim() !== '' ? fields.src : null;
  const fit = (fields.fit as 'contain' | 'cover' | undefined) ?? 'contain';
  const { className, style } = buildAnimationClasses(fields);

  if (!src) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'grid',
          placeItems: 'center',
          color: 'rgba(255,255,255,0.4)',
          fontFamily: 'system-ui, sans-serif',
          fontSize: 12,
          letterSpacing: 1.5,
          textTransform: 'uppercase',
        }}
      >
        No image set
      </div>
    );
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'grid',
        placeItems: 'center',
      }}
    >
      <div
        className={className}
        style={{
          ...style,
          width: '100%',
          height: '100%',
          // neon-glow renders box-shadow on this wrapper; keep it square.
          borderRadius: 4,
        }}
      >
        <img
          src={src}
          alt=""
          draggable={false}
          style={{
            width: '100%',
            height: '100%',
            objectFit: fit,
            display: 'block',
          }}
        />
      </div>
    </div>
  );
}
